import { ActionTypes, State, SETCONFIG } from "./types";

export const handleSetConfig = (role: State): ActionTypes => ({
  type: SETCONFIG,
  payload: role,
});
